import React from "react"
import { Box } from "@mui/material"
import {
	Create,
	PasswordInput,
	required,
	SimpleForm,
	TextInput,
	useNotify,
	useRedirect,
	useRefresh
} from "react-admin"

import { emailValidator } from "../utils/email-validator"
import { Separator } from "../utils/Separator"
import sx from "../utils/sx"
import FormGrid from "../utils/FormGrid"

export const UserCreate = (props) => {
	const notify = useNotify()
	const refresh = useRefresh()
	const redirect = useRedirect()

	const validateUserCreation = (values) => {
		const errors = {}

		if (values.password !== values.passwordConfirmation) {
			errors.passwordConfirmation = "Les mots de passe ne sont pas les même"
		}

		if (!emailValidator.test(values.email)) {
			errors.email = "Adresse email invalide"
		}

		return errors
	}

	const onSuccess = (data) => {
		notify(
			"Utilisateur %{firstName} %{lastName} créé",
			{
				type: "info",
				messageArgs: {
					firstName: data.firstName,
					lastName: data.lastName
				}
			}
		)
		redirect("/users")
		refresh()
	}

	return (
		<Create {...props}
			title="Création d'un utilisateur"
			mutationOptions={{ onSuccess }}
		>
			<SimpleForm validate={validateUserCreation}>
				<Box sx={sx.prose}>
					<TextInput
						label="Prénom"
						source="firstName"
						validate={required()}
						fullWidth
					/>
					<TextInput
						label="Nom"
						source="lastName"
						validate={required()}
						fullWidth
					/>
					<TextInput
						label="Email"
						source="email"
						type="email"
						validate={required()}
						fullWidth
					/>
					<Separator />
					<FormGrid>
						<PasswordInput
							label="Mot de passe"
							source="password"
							validate={required()}
							fullWidth
						/>
						<PasswordInput
							label="Confirmation de mot de passe"
							source="passwordConfirmation"
							validate={required()}
							fullWidth
						/>
					</FormGrid>
				</Box>
			</SimpleForm>
		</Create>
	)
}
